module.exports = __webpack_public_path__ + "media/site/images/jedziemyrazem-screen-0bb293fe708fb43526798e4cfd669fd9.jpg";